// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperNewsStory-cls1_z3d","cls2":"PaperNewsStory-cls2_yDc PaperNewsStory-cls1_z3d","variant-dense":"PaperNewsStory-variant-dense_E_X"};